import { ID } from "../../../types/general";
import { default as endpoints } from '../../../utils/data/endpoints';

const useEndPoints = (overrideOrigin?: string) => {
    const origin = overrideOrigin || process.env.REACT_APP_API_URL || 'http://localhost:4000';
    
    return endpoints;
};

export default useEndPoints;